import Vue from 'vue'
import Router from 'vue-router'
//登录
import login  from '@/pages/login'
//注册
import register  from '@/pages/register'
//下载
import download from '@/pages/download'
//代理管理
import runnability from '@/pages/runnability'
import myService from '@/pages/myService'
import taskRegister from '@/pages/taskRegister'
import aliyunkfRegister from '@/pages/aliyunkfRegister'
//合伙人注册登录
import providerRegister from '@/pages/providerRegister'
import providerLogin from '@/pages/providerLogin'
import providerHasLogin from '@/pages/providerHasLogin'
import providerBankCard from '@/pages/providerBankCard'


Vue.use(Router)
Vue.use(require('vue-wechat-title'))

export default new Router({
  mode: 'history',
  base: '/reginalAgent',
  routes: [
    {
      path: '/login',
      component: login,
      name: 'login',
      meta: {
        title: '区域代理-登录'
      }
    },
    {
      path: '/register',
      component: register,
      name: 'register',
      meta: {
        title: '注册淘金客'
      }
    },
    {
      path: '/aliyunkfRegister',
      component: aliyunkfRegister,
      name: 'aliyunkfRegister',
      meta: {
        title: '注册'
      }
    },
    {
      path: '/providerRegister',
      component: providerRegister,
      name: 'providerRegister',
      meta: {
        title: '注册'
      }
    },
    {
      path: '/providerLogin',
      component: providerLogin,
      name: 'providerLogin',
      meta: {
        title: '登录'
      }
    },
    {
      path: '/providerHasLogin',
      component: providerHasLogin,
      name: 'providerHasLogin',
      meta: {
        title: '修改资料'
      }
    },
    {
      path: '/providerBankCard',
      component: providerBankCard,
      name: 'providerBankCard',
      meta: {
        title: '绑定银行卡'
      }
    },
    {
      path: '/download',
      component: download,
      name: 'download',
      meta: {
        title: '下载淘金客'
      }
    },
    {
      path: '/runnability',
      component: runnability,
      name: 'runnability',
      meta: {
        title: '区域代理-运行情况'
      }
    },
    {
      path: '/myService',
      component: myService,
      name: 'myService',
      meta: {
        title: '区域代理-我的客服'
      }
    },
    {
      path: '/taskRegister',
      component: taskRegister,
      name: 'taskRegister',
      meta: {
        title: '注册'
      }
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js